export * from './lib/404'
export * from './lib/get-static-props'
